export interface INoteButton {
  label: string
  url: string
  type: 'button' | 'href'
}

export const IButtonType: Record<string, any> = { button: 'Button', href: 'Link' }

export interface INoteTemplate {
  id: number
  title: string
  notes: string
  links: INoteButton[]
  createdAt: string
  updatedAt: string
}
